import Icon ,{ IconsVariant } from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";

const PaymentAndDelivery =({
    name,
    isSelect,
    icon,
    onClick
}:{
    name:string;
    isSelect: boolean;
    icon: IconsVariant;
    onClick:()=>void;
}) => {
    const boxStyle = cn(
        "sm:min-h-58 min-h-35 flex flex-col bg-white border border-border rounded-4xl items-center center gap-2 p-2",
        isSelect &&
        "border-l-4 border-primary rounded-4xl bg-primary/10",
    );

    const nameStyle =cn(
        "text-center sm:h-18 h-auto text-text-tertiary leading-none hover:text-primary pt-2",
        isSelect && "text-primary",
    );
    const iconStyle ="flex sm:size-32 size-25 items-center justify-center rounded-full bg-grey shadow-lg";

    return(
        <div className={boxStyle} onClick={onClick}>
            <div className={iconStyle}>
                <Icon variants={icon} className="sm:size-20 size-15"/>
            </div>
            <span className={nameStyle}>{name}</span>
        </div>
    );

};
export default PaymentAndDelivery;